import { useState } from "react";
import { Link, usePage } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/dialog";
import { analyticsCookieChoice, setAnalyticsCookieChoice } from "@/lib/siteAnalytics";

const STATUS = {
  granted: "Analytics cookies are on in this browser.",
  denied: "Analytics cookies are off in this browser.",
  none: "You haven't chosen yet. They're on by default, except in Quebec, where they stay off until you turn them on.",
};

/**
 * Footer entry for turning Google Analytics cookies on or off. Only shown
 * on pages that load GA (the `site_analytics` shared prop), since nothing
 * else sets analytics cookies. See lib/siteAnalytics.js.
 */
export default function AnalyticsCookieSettings({ className }) {
  const { site_analytics: siteAnalytics, routes } = usePage().props;
  const [open, setOpen] = useState(false);
  const [choice, setChoice] = useState(null);

  if (!siteAnalytics) return null;

  const openSettings = () => {
    setChoice(analyticsCookieChoice());
    setOpen(true);
  };

  const choose = (value) => {
    setAnalyticsCookieChoice(value);
    setChoice(value);
    setOpen(false);
  };

  return (
    <li>
      <button type="button" onClick={openSettings} className={className}>
        Cookie settings
      </button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        title="Cookie settings"
        description="Our public pages use Google Analytics cookies to count visits and see how people find us. They're never used on student, school, donation, or signed-in pages."
      >
        <p className="mb-5 text-sm leading-relaxed">{STATUS[choice || "none"]}</p>
        <div className="flex flex-wrap gap-3">
          <Button data-autofocus onClick={() => choose("granted")}>
            Turn on
          </Button>
          <Button variant="outline" onClick={() => choose("denied")}>
            Turn off
          </Button>
        </div>
        <p className="mt-5 text-xs text-muted-foreground">
          Details are in our{" "}
          <Link href={routes.privacy} className="underline hover:text-primary" onClick={() => setOpen(false)}>
            Privacy Policy
          </Link>
          .
        </p>
      </Dialog>
    </li>
  );
}
